import { Component, OnInit }        from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>',
})
export class SimpleLayoutComponent implements OnInit {

    constructor() { }

    ngOnInit(): void { 
    }
}
